import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  reduxForm
} from 'redux-form';
import {
  ErrorMessage,
  ForgotPasswordButton,
  SubmitButton,
  TextField
} from './../components';

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  if (!values.password) {
    errors.password = 'Required'
  } else if (values.password.length <= 5) {
    errors.password = 'Password must be more than 5 characters long';
  } else if (values.password.length >= 100) {
    errors.password = 'Password must be less than 100 characters long';
  }

  return errors
};

const SignInForm = ({
  handleSubmit,
  changeState,
  errorMessage = false,
  working = false,
}) => {
  return (
    <Fragment>
      <form
        className="sign-in auth__form"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <div className="auth--form-group">
          <Field
            name="email"
            component={TextField}
            label="Email"
            type="email"
            props={{
              disabled: working
            }}
          />
        </div>
        <div className="auth--form-group">
          <Field
            name="password"
            component={TextField}
            label="Password"
            type="password"
            props={{
              disabled: working
            }}
          />
        </div>
        <ForgotPasswordButton
          changeState={changeState}
        />
        <SubmitButton
          busy={working}
          textOnBusy="Signing In"
          textOnIdle="Sign In"
        />
        <ErrorMessage errorMessage={errorMessage} />
      </form>
    </Fragment>
  )
};

SignInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  working: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'auth/sign-in',
  validate
})(SignInForm);


// WEBPACK FOOTER //
// ./src/components/Authentication/SignIn/SignInForm.js